<template lang="pug">
v-menu(
  v-bind="extendAttrs"
  v-on="$listeners"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(:name="name" v-bind="data")
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")

</template>

<script>
import { VMenu } from 'vuetify/lib';

export const BASE_MENU_ATTRS = {
  offsetY: true,
  contentClass: 'ui-design ui-box-shadow ui-select-menu ui-scrollbar rounded-12',
  nudgeTop: -12,
  closeOnClick: true,
};

export default {
  components:  { VMenu },
  props: {},
  data() {
    return {};
  },
  computed: {
    extendAttrs() {
      return {
        ...BASE_MENU_ATTRS,
        ...this.$attrs,
      };
    },
  },
};
</script>
